<script>
    export default {
        name: "BrandLink",
        props: {
            slug: String,
            isAnimated: Boolean,
        },
    };
</script>

<template>
    <div class="brand-link-wrapper" :class="{ 'is-animated': isAnimated }">
        <router-link class="brand-link" :to="{ name: 'Product', params: { slug: this.slug } }">
            <span>Подробнее</span>
        </router-link>
    </div>
</template>

<style lang="scss">
    .brand-link-wrapper {
        width: 100%;
        overflow: hidden;
        &.is-animated {
            .brand-link {
                @include clip-path(polygon(0 0, 0 0, 0 100%, 0% 100%));
            }
        }
        @include bp($bp-tablet-md) {
            max-width: 300px;
        }
    }

    .brand-link {
        position: relative;
        z-index: 1;
        display: block;
        width: 100%;
        max-width: 100%;
        height: 50px;
        color: #fff;
        font-weight: 500;
        font-size: 14px;
        line-height: 46px;
        text-align: center;
        text-transform: uppercase;
        background-color: #fff;
        border: 1px solid var(--primary);
        cursor: pointer;
        @include clip-path(polygon(0 0, 100% 0, 100% 100%, 0% 100%));
        transition: all 0.5s ease-in 0.5s;
        span {
            transition: color 0.2s ease-in;
        }
        &:hover {
            &::before {
                transform: scaleX(0);
            }
            span {
                color: var(--primary);
            }
        }
        &::before {
            content: "";
            @include center-absolute(-1px);
            z-index: -1;
            background: var(--primary);
            transform: scaleX(1);
            transform-origin: left;
            transition: transform 0.3s ease-in;
        }
        @include bp($bp-desktop-lg) {
            font-size: 16px;
        }
    }
</style>
